export default "__VITE_ASSET__BU0gxk$D__"